/*
 * Purpose: Journey Tube block — Director leaves open path to outcome when pacing is natural
 * Last modified: 2026-06-27 | Agent
 * Completeness: 95
 */
import type { Node } from '@/stores/workflowStore';
import { initializePlacementContext } from '@/lib/blockContext';
import { getBlockTypeLabel } from '@/lib/blockTypes';

const genId = () => Math.random().toString(36).slice(2, 11);

export function createJourneyTubeNode(
  missionId: string,
  phases: string[],
  x = 300,
  y = 120
): Node {
  const label = getBlockTypeLabel('tube', 'journey');
  return {
    id: genId(),
    type: 'tube',
    subtype: 'journey',
    config: {
      ...initializePlacementContext(missionId, 'tube', 'journey', label),
      contextLabel: 'Journey Tube',
      contextPurpose: 'Open path to the outcome — blocks attach as the journey clarifies',
      journeyPhases: phases,
      placementStatus: 'connected',
    },
    x,
    y,
  };
}
